<!-- 修改品宣图配置弹框 -->
<template>
    <div>
        <veui-dialog
            title="品宣图设置"
            :open="showModal"
            :overlay-class="'modify-banners-dialog'"
            @cancel="closeDialog()"
        >
            <!-- 加载veui-dialog上打不上点 -->
            <div
                v-visually="{
                    serverId: 17079,
                    area: 'banner-dialog',
                }"
                class="item"
            >
                <div class="label">模板颜色选择</div>
                <veui-radio-group
                    v-model="colorValue"
                    :items="colorRadios"
                    class="color"
                />
            </div>
            <div class="item">
                <div class="label">附加描述</div>
                <veui-radio-group
                    v-model="describeValue"
                    class="desc"
                    :items="describeRadios"
                />
            </div>
            <div v-if="describeValue === 'idea'" class="input">
                <veui-input
                    v-model="idea"
                    class="idea-input"
                    maxlength="25"
                    :strict="true"
                    placeholder="请输入执业理念"
                />
            </div>
            <!-- 预览 -->
            <div class="preview-box">
                <div class="title">预览效果</div>
                <banner-card
                    overlay-class="preview"
                    :is-show-idea="describeValue === 'idea'"
                    :lawyer-info="{...lawyerInfo, register_philosophy: idea || lawyerInfo.register_philosophy}"
                    :background="colorValue"
                />
            </div>
            <template #foot>
                <veui-button
                    ui="strong"
                    class="close"
                    @click="closeDialog()"
                >
                    取消
                </veui-button>
                <veui-button
                    ui="primary"
                    class="submit"
                    @click="submit"
                >
                    保存
                </veui-button>
            </template>
        </veui-dialog>
        <veui-dialog
            title="温馨提示"
            :open="showTipModal"
            :overlay-class="'modify-banners-dialog'"
            @cancel="closeDialog()"
        >
            <div
                class="item items"
            >
                <div class="label">为了保证PC主页品宣信息的权威度，需要您补充部分个人信息，请前往我的认证页面查看。</div>
            </div>
            <template #foot>
                <veui-button
                    ui="primary"
                    class="submit"
                    @click="goToAnthority"
                >
                    去查看
                </veui-button>
                <veui-button
                    ui="strong"
                    class="close"
                    @click="closeDialog()"
                >
                    稍后再说
                </veui-button>
            </template>
        </veui-dialog>
    </div>
</template>

<script>
import {RadioGroup, Dialog, Button, Input} from 'veui';
import bannerCard from '../components/banner-card.vue';
import {BG_ARR} from '../config/index';
import {mapActions, mapState} from 'vuex';
export default {
    components: {
        'veui-radio-group': RadioGroup,
        'veui-dialog': Dialog,
        'veui-button': Button,
        'banner-card': bannerCard,
        'veui-input': Input
    },
    props: {
        lawyerInfo: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            describeValue: 'domain',
            describeRadios: [
                {value: 'domain', label: '擅长领域'},
                {value: 'idea', label: '执业理念'}
            ],
            colorValue: '',
            colorRadios: BG_ARR,
            // 执业理念
            idea: '',
            showModal: true,
            showTipModal: false
        };
    },
    computed: {
        ...mapState({
            userInfo: state => state.lawStore.userInfoNew || {}
        })
    },
    watch: {
        lawyerInfo: {
            handler(val) {
                this.colorValue = val.appearance_config?.color_config?.back_ground || this.colorRadios[0].value;
                this.idea = val.register_philosophy || '';
                this.describeValue = +val.appearance_config?.description === 2 ? 'idea' : 'domain';
            },
            immediate: true
        },
        colorValue(val) {
            let index = this.colorRadios?.findIndex(item => item.value === val) || 0;
            this.$wywLog.send({
                serverId: 17079,
                action: 'click',
                area: 'dialog-color' + (index + 1)
            });
        },
        describeValue(val) {
            this.$wywLog.send({
                serverId: 17079,
                action: 'click',
                area: val === 'domain' ? 'dialog-domain' : 'dialog-idea'
            });
        }
    },
    methods: {
        ...mapActions({
            submitInfo: 'lawStore/submitInfo',
            saveAppearanceConfig: 'lawStore/saveAppearanceConfig'
        }),
        goToAnthority() {
            this.$router.push({
                path: '/material'
            });
        },
        closeDialog() {
            this.showModal = true;
            this.showTipModal = false;
            this.$wywLog.send({
                serverId: 17079,
                action: 'click',
                area: 'dialog-cancel'
            });
            this.$emit('close');
        },
        // 保存配置
        submit() {
            this.$wywLog.send({
                serverId: 17079,
                action: 'click',
                area: 'dialog-submit'
            });
            let color = this.colorRadios.find(item => item.value === this.colorValue) || this.colorRadios[0];
            const {label: color_name, value: back_ground, color: color_value} = color;
            if (this.describeValue === 'idea' && !this.idea) {
                this.$toast.error('请填写执业理念');
                return;
            }
            if (this.describeValue === 'idea' && this.userInfo.pass_info && this.userInfo.pass_info.pass_status < 2) {
                this.showModal = false;
                this.showTipModal = true;
                return;
            }
            const params = {
                isIdea: this.describeValue === 'idea',
                color_name,
                color_value,
                back_ground,
                description: this.describeValue === 'domain' ? '1' : '2',
                ...this.describeValue === 'idea' && {register_philosophy: this.idea}
            };
            this.describeValue === 'domain' && this.saveAppearanceConfig(params).then(res => {
                this.$toast.success('修改成功');
                this.$emit('submit', params);
            }).catch(res => {
                this.$toast.error(res && res.msg || '修改失败，请稍候再试~');
            });
            this.describeValue === 'idea' && this.submitInfo(params).then(res => {
                if (res && +res.code === 10002) {
                    this.showModal = false;
                    this.showTipModal = true;
                    return;
                }
                this.$toast.success('修改成功');
                this.$emit('submit', params);
            }).catch(res => {
                this.$toast.error(res && res.msg || '修改失败，请稍候再试~');
            });
        }
    }
};
</script>

<style lang='less' scoped>
.modify-banners-dialog {

    /deep/.veui-dialog-content {
        width: 563px;
    }

    /deep/.veui-dialog-content-body {
        overflow-x: hidden;
    }
    .item {
        display: flex;
        margin-top: 10px;

        &::before {
            content: "";
            height: 16px;
            width: 16px;
            font-weight: 900;
            margin-top: 4px;
            margin-right: 4px;
            background: url('https://lvlin-base.cdn.bcebos.com/fe-saas/page/personal-info/required.png') no-repeat center center / 100% 100%;
        }

        &:first-child {
            margin-top: 6px;
        }

        .label {
            width: 122px;
        }

        /deep/.veui-radio-group {
            .veui-radio:first-child{
                margin-left: 15px;
            }
        }

        /deep/.veui-radio-group.color {
            .veui-radio:not(:first-child){
                margin-left: 33px;
            }
        }

        /deep/.veui-radio-group.desc {
            .veui-radio:not(:first-child){
                margin-left: 20px;
            }
        }
    }

    .items {
        .label {
            width: 100%;
        }
        &::before {
            display: none;
        }
    }

    .input {
        margin-top: 10px;
        margin-left: 135px;
    }

    .idea-input {
        width: 100%;
    }

    .preview-box {
        .title {
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #1E1F24;
            line-height: 14px;
            font-weight: 500;
            margin-top: 30px;
            margin-bottom: 24px;
        }

        .promotional-images {
            width: 100%;
            height: 134px;

            /deep/.lawyer-avatar {
                height: 105px;
                width: 105px;
                margin-left: 126px;
                margin-top: 7px;
            }

            /deep/.lawyer-info {
                margin-left: 18px;
                color: #fff;

                .row {
                    width: 340px;

                    &:not(:first-child) {
                        margin-top: 10px;
                    }

                    &:nth-child(2) {
                        .small_sise(20px, top);
                    }

                    &:nth-child(3) {
                        .small_sise(12px, top);
                        margin-top: -2px;
                    }
                    &:nth-child(4) {
                        margin-top: 2px;
                    }

                    &:first-child {
                        margin-top: 18px;
                    }

                    .name {
                        font-size: 16px;
                    }

                    .job {
                        margin-left: 4px;
                        .small_sise(20px, bottom);
                    }

                    .phone {
                        height: 30px;
                        padding: 0 21px;
                        color: #422b16;
                        .small_sise(12px, top);
                        line-height: 30px;
                        text-align: center;
                        background: linear-gradient(90deg, #fcda8f, #ffedb3);
                        border-radius: 2px;
                    }
                }
            }
        }
    }

    /deep/.veui-dialog-content-foot {
        display: flex;
        justify-content: center;
        padding-top: 24px;

        .veui-button {
            width: 90px;
            height: 40px;
            border: 1px solid rgba(0,85,255,1);
            border-radius: 5px;

            &:last-child {
                margin-left: 30px;
            }
        }
    }
}

</style>
